// Generated by ts-to-zod
import {z} from "zod";
import {mantineStylesApiSchema} from "./primitives.zod";

export const mantineAccordionPanelPropsSchema = z.strictObject({
	styles: mantineStylesApiSchema.optional(),
});
